import React, { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import { Box, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router";
import {useDispatch, useSelector} from "react-redux"
import CancelIcon from '@mui/icons-material/Cancel';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import api from "../../../API";

interface IFileTypes {
  id: number;
  object: File;
}

interface UploadResult {
  fileName: string;
  state: string;
}

const DialogUploadPage = (props:any) => {

  const [backdrop, setBackdrop] = useState<boolean>(false)

  const [isDragging, setIsDragging] = useState<boolean>(false);
  const [files, setFiles] = useState<IFileTypes[]>([]);
  const [uploadResult , setUploadResult] = useState<UploadResult[]>([]);

  const dragRef = useRef<HTMLLabelElement | null>(null);
  const fileId = useRef<number>(0);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;
  
  const fileUpload = async () => {
    if (files.length === 0) {
      alert("업로드할 파일을 선택해주세요.");
      return;
    }
    const formData = new FormData();
    // 선택한 파일들을 formData에 추가
    // const file_data:any = {};

    let audio_cnt = 0;
    let srt_cnt = 0;
    let img_cnt = 0;

    formData.append("email", email);

    files.forEach((file) => {
      console.log('업로드할 파일' , file.object)
      const extension = file.object.name.split(".").pop();
      console.log('extension', extension)
      
      if(extension && ["mp3","mp4","wav","ogg","m4a","aac"].includes(extension.toLowerCase())){
        formData.append("audio", file.object.name);
        audio_cnt +=1;
      }
      else if(extension && ["srt"].includes(extension.toLowerCase())){
        formData.append("srt", file.object.name);
        srt_cnt +=1;
      }
      else if(extension && ["png","jpg","jpeg"].includes(extension.toLowerCase())){
        formData.append("photo", file.object.name);
        img_cnt +=1;
      }
      else{
        alert(file.object.name + ' 확장자를 확인하여주세요.')
        return;
      }
      formData.append("files", file.object);

    });

    if(audio_cnt != 1){
      alert('녹음파일 1개를 업로드 해주세요.')
      return;
    }
    if(srt_cnt != 1){
      alert('자막파일(srt)은 1개를 업로드 해주세요.')
      return;
    }

    if(img_cnt < 1){
      alert('사진파일(녹음환경)은 1개 이상 업로드 해주세요.')
      return;
    }
    // console.log('file_data',file_data)
    // let difference = ["mp3","mp4","wav","ogg","m4a","aac","srt","txt","png","jpg","jpeg"].filter(x => file_extension.includes(x)); 
    

    // if(difference.length < 3){
    //   alert('1. 음성파일, 2.텍스트파일, 3.사진파일 총 3개 파일을 업로드하여야 합니다.')
    //   return;
    // }

    // return;
      
    setBackdrop(true)
    const result = await api.post("/dialogUploadSample", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
        // "Content-Type": "application/json"
      }
    })
    .then((res:any) => {
      setBackdrop(false); 
      console.log("file upload ", res.data.datas); 
      setUploadResult(res.data.datas); 
      setFiles([]);
      alert('업로드가 완료되었습니다. 샘플 확인이 완료되면 문서를 제출하여 주시기 바랍니다.')
      props.sampleUploadList();
    })
    // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {
      setBackdrop(false); 
      // var res = JSON.parse(error.response.data);
      // console.error('에러',res); 
      alert('샘플 파일 업로드에 실패하였습니다.')
      // alert(res['fileName'] + ' 파일은 이미 업로드 되어있습니다. [상태 : ' + res['state'] + ']')
    })
    // alert("파일 업로드 실패. " + error.response.data.error);
      
  };

  const onChangeFiles = useCallback(
    (e: ChangeEvent<HTMLInputElement> | any): void => {
      let selectFiles: File[] = [];
      let tempFiles: IFileTypes[] = files;
  
      if (e.type === "drop") {
        selectFiles = e.dataTransfer.files;
      } else {
        selectFiles = e.target.files;
      }
  
      for (const file of selectFiles) {
        const extension = file.name.split(".").pop();
  
        // 파일업로드 확장자 통과목록

        // if (extension === "mp3" || extension === "wav" || extension === "ogg" || extension === "m4a" || extension === "M4A") {

        const isDuplicate = tempFiles.some(
          (tempFile) =>
            tempFile.object.name === file.name
        );
        if (isDuplicate) {
          alert(`${file.name} 파일은 이미 추가되었습니다.`);
        } else if (
          extension &&
          ["mp3","mp4","wav","ogg","m4a","aac","srt","txt","png","jpg","jpeg"].includes(extension.toLowerCase())
        ) {
        tempFiles = [
          ...tempFiles,
          {
            id: fileId.current++,
            object: file,
          },
        ];
        } else {
          // alert("오디오 파일만 업로드 가능합니다.");
          alert("업로드가 불가한 파일 확장자를 포함합니다. 다시확인하여 주세요.");
        }
      }
      console.log("tempFiles", tempFiles);
      setFiles(tempFiles);
    },
    [files]
  );

  const handleFilterFile = useCallback(
    (id: number): void => {
      setFiles(files.filter((file: IFileTypes) => file.id !== id));
    },
    [files]
  );

  const handleDragIn = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const handleDragOut = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    setIsDragging(false);
  }, []);

  const handleDragOver = useCallback((e: DragEvent): void => {
    e.preventDefault();
    e.stopPropagation();

    if (e.dataTransfer!.files && e.dataTransfer!.files.length > 0) {
      const extension = e.dataTransfer!.files[0].name.split(".").pop();
      if (extension && ["mp3","wav","ogg","m4a","srt","txt","png","jpg","jpeg"].includes(extension.toLowerCase())
      ) {
        setIsDragging(true);
      } else {
        setIsDragging(false);
      }
    }
  }, []);

  const handleDrop = useCallback(
    (e: DragEvent): void => {
      e.preventDefault();
      e.stopPropagation();

      onChangeFiles(e);
      setIsDragging(false);
    },
    [onChangeFiles]
  );

  const initDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.addEventListener("dragenter", handleDragIn);
      dragRef.current.addEventListener("dragleave", handleDragOut);
      dragRef.current.addEventListener("dragover", handleDragOver);
      dragRef.current.addEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  const resetDragEvents = useCallback((): void => {
    if (dragRef.current !== null) {
      dragRef.current.removeEventListener("dragenter", handleDragIn);
      dragRef.current.removeEventListener("dragleave", handleDragOut);
      dragRef.current.removeEventListener("dragover", handleDragOver);
      dragRef.current.removeEventListener("drop", handleDrop);
    }
  }, [handleDragIn, handleDragOut, handleDragOver, handleDrop]);

  

  useEffect(() => {
    initDragEvents();

    return () => resetDragEvents();
  }, [initDragEvents, resetDragEvents]);


  return (
        <React.Fragment>
          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdrop} >
            <CircularProgress color="inherit" /> 업로드 중...
          </Backdrop>
        
          <Paper sx={{ margin: "-56px", padding: "56px", borderTop: "4px solid #3e36a5", width:"700px"}}>
            <Box sx={{padding:"20px 8px 8px 8px"}}>
              <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "32px", letterSpacing:"-2px"}}>대화 샘플 파일 제출</Box>
              <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
              <div className="DragDrop">
              <input
                type="file"
                id="fileUpload"
                style={{ display: "none" }}
                multiple={true}
                onChange={onChangeFiles}
              />

              <label
                className={isDragging ? "DragDrop-File-Dragging" : "DragDrop-File"}
                htmlFor="fileUpload"
                ref={dragRef}
                style={{width: "100%" , backgroundColor:"#71a7e5"}}
              >
                <Box sx={{fontWeight:700, fontSize:"32px", color:"#fff"}}>파일 첨부</Box>
              </label>
              
              <div className="DragDrop-Files">
                {files.length > 0 &&
                  files.map((file: IFileTypes) => {
                    const {
                      id,
                      object: { name },
                    } = file;

                    return (
                      <div key={id}>
                        <div>{name}</div>
                        <div
                          className="DragDrop-Files-Filter"
                          onClick={() => handleFilterFile(id)}
                        >
                          <CancelIcon fontSize="small" />
                        </div>
                      </div>
                    );
                  })}
              </div>
              {(uploadResult.length > 0) && (files.length === 0) ? 
                (<React.Fragment>
                  <Box sx={{fontSize:"20px", fontWeight:600}}>파일 업로드 결과</Box>
                  {uploadResult.map((result:UploadResult) => 
                    <Box display="flex" sx={{padding:2}} key={result.fileName}>
                      <Box sx={{fontWeight:600}}>{result.fileName}</Box>
                      {result.state == "성공" ? 
                        <Box sx={{marginLeft:"8px", fontWeight:600, color:"#27c527", display:"flex"}}><ExpandCircleDownIcon sx={{marginRight:1, color:"#27c527"}} />{result.state}</Box>
                        : 
                        <Box sx={{marginLeft:"8px", fontWeight:600, color:"red", display:"flex"}}><CancelIcon sx={{marginRight:1}} />{result.state}</Box>}
                    </Box>
                  )}
                </React.Fragment>)
              : ""}
              <Box sx={{display:"flex" , justifyContent: "end"}}>
                <Button sx={{width: "230px", fontWeight: 600, backgroundColor: "#3bbd30", color: "#fff"}} variant="contained" onClick={fileUpload}>파일 업로드</Button>
              </Box>
            </div>
            </Box>
            <Box sx={{fontWeight:500, marginLeft:2}}>
              <Box color="blue">샘플파일을 첨부해주세요! {<b style={{color:"red"}}>(총 3개의 파일)</b>}</Box>
              <Box color="blue">녹음한 {<b style={{color:"red"}}>음성파일</b>} , 자막정보 및 대화 {<b style={{color:"red"}}>텍스트파일</b>} , 녹음환경 {<b style={{color:"red"}}>사진파일</b>}</Box>
              <Box color="blue">음성을 녹음한 장소(공간)을 확인하기위한 사진 1장 이상을 첨부하여주세요.</Box>
              <Box>클로바노트를 사용하여 녹음한 음성파일로 SRT 자막 생성을 진행해주세요.</Box>
              <Box><b style={{marginLeft:"16px"}}>(<a href="https://clovanote.naver.com/home" target="_blank" rel="noopener noreferrer">클로바노트 사이트 이동</a>)</b></Box>
              <Box color="blue">첨부한 샘플파일은 관리자 검토 후 적합여부를 통지 합니다.(처리기간 4일 이내)</Box>
            </Box>
          </Paper>
        </React.Fragment>
  );
};

export default DialogUploadPage;
